// import mpro from './mpro.init';

const pageShowEvent = function pageShowEvent(event) {
	// Page restored from BFCache
	if (event.persisted) {
		const freezeTimePage = document.documentElement.dataset.pageStateFrozen;
		mpro.isDev && console.debug('🌟 This page was restored from the BFcache (freezeTime Page: %o, freezeTime Memory: %o).', freezeTimePage, freezeTime);
		if (freezeTimePage !== freezeTime) {
			mpro.isDev && console.debug('🛑 Page freeze time is different (freezeTime Page: %o, freezeTime Memory: %o).', freezeTimePage, freezeTime);
		}
		mpro.emit('page.restore', { type: 'page.restore' });
	}
	// Page loaded normally
	else {

		// Disable popstate auto-scrolling
		if (mpro?.config?.page.scroll_restoration === 'manual') {
			window.history.scrollRestoration = 'manual';
		}

		// console.log('This page was loaded normally.');
		mpro.emit('page.show', { type: 'page.show' });
	}
};

let freezeTime = null;

const pageHideEvent = function pageHideEvent(event) {
	// Page might be sent to BFCache
	if (event.persisted === true) {
		freezeTime = (new Date()).toISOString();
		document.documentElement.dataset.pageStateFrozen = freezeTime;
		mpro.isDev && console.debug('🥶 This page *might* be entering the BFcache (freezeTime: %o).', freezeTime);
		mpro.emit('page.freeze', { type: 'page.freeze' });
	}
	// Page unloaded normally
	else {
		mpro.isDev && console.debug('📴 This page will unload normally and be discarded.');
		mpro.emit('page.hide', { type: 'page.hide' });
	}
};

mpro.initPageEvents = () => {
	window.addEventListener('pageshow', pageShowEvent);
	window.addEventListener('pagehide', pageHideEvent);
};

mpro.removePageEvents = () => {
	window.removeEventListener('pageshow', pageShowEvent);
	window.removeEventListener('pagehide', pageHideEvent);
};

// Shortcut helpers
mpro.onPageFreeze = (handler) => {
	mpro.on('page.freeze', handler);
};
mpro.oncePageFreeze = (handler) => {
	mpro.once('page.freeze', handler);
};
mpro.offPageFreeze = (handler) => {
	mpro.off('page.freeze', handler);
};
mpro.onPageRestore = (handler) => {
	mpro.on('page.restore', handler);
};
mpro.oncePageRestore = (handler) => {
	mpro.once('page.restore', handler);
};
mpro.offPageRestore = (handler) => {
	mpro.off('page.restore', handler);
};

export default mpro;
